module.exports = __webpack_public_path__ + "img/6.69a97e33.jpg";